import {Session} from "../../models/session";
import {appRoute} from "../../utils/routes";
import {Box, Button, Card, Chip, ColorPaletteProp, Stack, Typography} from "@mui/joy";
import React, {useState} from "react";
import {Link} from "react-router-dom";
import {formatTimeElapsed} from "../../utils/formatTimeElapsed";
import {CircleArrowRight, EyeIcon} from "lucide-react";
import {ExamType} from "../../models/exam";
import TestResultComponent from "./TestResultComponent";
import {useTranslation} from "react-i18next";

type TestResultItemComponentProps = {
    session: Session,
    testTitle: string,
    examType?: ExamType,
}

const TestResultItemComponent = (props: TestResultItemComponentProps) => {
    const {t} = useTranslation()
    const [resultVisible, setResultVisible] = useState(false)
    return <Card data-no-glow data-light data-no-animation data-focus sx={{padding: 2.5}}>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
            <Stack width={"100%"}>
                <Stack width={"100%"} direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography level={"h4"}>
                        {props.testTitle}
                    </Typography>

                    <Typography level={"h1"}>
                        {props.session.overallScore}
                    </Typography>

                </Stack>

                <Typography level={"body-sm"}>
                    {formatTimeElapsed(new Date().getTime() - props.session.startedAt)} ago
                </Typography>
            </Stack>
        </Stack>
        <Stack gap={1.5} alignItems={"center"} direction={{sm: "row"}} justifyContent={"space-between"}>
            <Button component={Link}
                    to={appRoute(`practice/${props.session.sections?.[0]}?testId=${props.session.testId}&mode=${props.session.mode}`)}
                    sx={{alignSelf: "flex-end", width: {xs: "100%"}}} startDecorator={<CircleArrowRight/>}>
                {t("retakeTestActionButtonLabel")}
            </Button>

            <Button onClick={() => setResultVisible(true)} sx={{alignSelf: "flex-end", width: {xs: "100%"}}}
                    startDecorator={<EyeIcon/>}
                    variant={"outlined"} color={"neutral"}>
                {t("viewDetailedTestResultsActionButtonLabel")}
            </Button>
        </Stack>

        <TestResultComponent session={props.session} testTitle={props.testTitle} open={resultVisible}
                             onClose={() => setResultVisible(false)}/>
    </Card>
}

export default TestResultItemComponent